module.exports = __webpack_public_path__ + "static/media/myneflix4.616b1c99.png";